// extracted by mini-css-extract-plugin
export default {"header":"MoopHeader_header__3eVPl","left":"MoopHeader_left__--1D1","actionsSlot":"MoopHeader_actionsSlot__iYPrt","right":"MoopHeader_right__YeuMJ"};